export default __webpack_public_path__ + "static/media/Image3.a7305d3e.jpeg";